























































































/* General */
import Vue from 'vue'

/* Mixins */

/* Components */
import TicketPortalHeader from './components/ticket-portal-header.vue'
import TicketPortalFooter from './components/ticket-portal-footer.vue'

/* Helpers */

/* Data types */
import { IAttachment } from '@/types/data-objects/attachments'

/* API */
import TicketPortalAPI from '@/api/modules/ticket-portal.api'
import {
  ITicketPortalOutputDetail,
  ITicketPortalOutputDetailThreadEvent,
} from '@/api/types/response.types'
import { ITicketPortalInputReplyFromCustomer } from '@/api/types/request.types'

export default Vue.extend({
  name: 'TicketPortalListing',

  metaInfo(): any {
    return {
      title: this.detail.ticketPortalName,
    }
  },

  components: { TicketPortalHeader, TicketPortalFooter },

  data() {
    return {
      isLoading: true,
      isSubmitting: false,
      detail: {} as ITicketPortalOutputDetail,
      message: '',
      fileUploadIDs: [] as number[],
    }
  },

  computed: {
    ticketID(): number {
      return parseInt(this.$route.params.ticketId, 10)
    },
    isOfficeClosed(): boolean {
      return (
        this.detail.listOpenHoursInfos !== null &&
        this.detail.isOutsideOfficeHours
      )
    },
  },

  async created() {
    this.isLoading = true
    await this.getTicketDetail()
    this.isLoading = false
  },

  methods: {
    addFileHandler(files: IAttachment[]) {
      this.fileUploadIDs = files.map(item => item.id)
    },
    async removeFileHandler(id: number) {
      try {
        await TicketPortalAPI.delete_FileUploadDelete(this.ticketID, id)
        this.fileUploadIDs = this.fileUploadIDs.filter(f => f !== id)
      } catch (error) {
        this.$messaging.showGenericError()
      }
    },
    async getTicketDetail() {
      try {
        this.detail = await TicketPortalAPI.get_Detail(this.ticketID)
      } catch (error) {
        this.$error.emit(error)
      }
    },
    async addReply() {
      try {
        this.isSubmitting = true
        const data = {
          message: this.message,
          listFileUploadIDs: this.fileUploadIDs,
        } as ITicketPortalInputReplyFromCustomer
        const response = await TicketPortalAPI.post_ReplyFromCustomer(
          this.ticketID,
          data,
        )
        this.$messaging.showSuccess(response.message)
        this.clearMessage()
        await this.getTicketDetail()
        this.isSubmitting = false
      } catch (error) {
        this.$error.emit(error)
      }
    },
    clearMessage() {
      this.message = ''
    },
    hasOtherInfo(a: ITicketPortalOutputDetailThreadEvent): boolean {
      return (
        (a.listAttachments !== null && a.listAttachments.length > 0) ||
        (a.ccs !== null && a.ccs.length > 0) ||
        a.bounceInfo !== null ||
        a.autoResponseSent
      )
    },
  },
})
